<h2 mat-dialog-title class="dialog-title">
  <mat-icon color="warn">warning</mat-icon>
  未保存の変更があります
</h2>

<mat-dialog-content>
  <p>このページには保存されていない変更があります。</p>
  <p>ページを離れると変更内容は失われます。</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">キャンセル</button>
  <button mat-flat-button color="warn" (click)="onConfirm()">
    <mat-icon>exit_to_app</mat-icon>
    保存せずに離れる
  </button>
</mat-dialog-actions>
